import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ErpService } from '../../service/erp.service'
import * as $ from 'jquery';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-erp-btn',
  templateUrl: './app-erp-btn.component.html',
  styleUrls: ['./app-erp-btn.component.css']
})
export class AppErpBtnComponent implements OnInit, AfterViewInit {

    @Input('pk') pk: number;
    @Input('loan_type') loan_type = "";
    transfer_to_erp_btn: boolean = false;
    get_olap_erp_loan_app_sub: Subscription;
    constructor(private erpService: ErpService) {}

    ngOnInit() {
        // console.log('AppErpBtnComponent:ngOnInit');
    }

    ngAfterViewInit() {
        // console.log('AppErpBtnComponent:ngAfterViewInit', this.pk);
        this.get_olap_erp_loan_app_sub = this.erpService.get_olap_erp_loan_app(this.pk)
            .subscribe((resp: any) => {
                this.transfer_to_erp_btn = !resp.status;
                if (!resp.msg.loan_app_id)
                    this.transfer_to_erp_btn = true;
            }, (err) => {
                this.transfer_to_erp_btn = !err.error.status;
            })
    }

    submitToERP() {
        $('.transfer_to_erp_btn').text('Uploading data to ERP...').prop('disabled', true);
        this.erpService.create({'loan_id': this.pk, 'action': 'create'})
            .subscribe((resp) => {
                // console.log('submitToERP: resp => ', resp.status);
                if (resp.status)
                    this.transfer_to_erp_btn = false;
            }, (err) => {
                // console.log('submitToERP: error => ', err.error);
                this.transfer_to_erp_btn = true;
                $('.transfer_to_erp_btn').text('Submit to ERP').prop('disabled', false);
            });
    }

    ngOnDestroy(): void {
        this.get_olap_erp_loan_app_sub.unsubscribe();
    }

}



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/components/app-erp/app-erp-btn.component.ts